module.exports = __webpack_public_path__ + "img/ZJ5150.c97c298d.png";